module.exports = __webpack_public_path__ + "media/images/subject_img/MANAGEMENT-BUSINESS ADMINISTRATION-9146d5569b2eaf0b177e298d53058d56.jpg";